/*=====================================
=            Tablet Header            =
=====================================*/

function bindTabletHeaderSearch() {

  // Unbind click event
  $('#header-search-btn').off('click');
  // Bind click event
  $('#header-search-btn').on('click', function(e) {
    e.preventDefault();

    var searchButton = $('#header-search-btn'),
        searchBox = $('#header-search-box'),
        searchString = searchBox.val(),
        searchForm = $(this).closest('form'),
        inputWidth = 200;

    // Unbind click to allow animation to complete
    searchButton.off('click');

    // If searchString is empty, and isn't active, animate and show field
    if ( searchString.length < 1 && !searchBox.hasClass('active') ) {
      searchButton.addClass('active');
      searchBox.focus();
      searchBox.addClass('active').animate({ width: inputWidth }, '800', function() {
        // Rebind header search
        bindTabletHeaderSearch();
      });
    }
    // If searchString is empty, and field is already active, animate and hide field
    else if ( searchString.length < 1 && searchBox.hasClass('active') ) {
      searchBox.animate({ width: 0 }, '800', function() {
        searchBox.removeClass('active');
        searchButton.removeClass('active').blur();
        // Rebind header search
        bindTabletHeaderSearch();
      });
    }
    // If searchString is not empty, submit search
    else {
      // Change icon to spinner
      searchButton.find('.fa').removeClass('fa-search').addClass('fa-spinner fa-spin').css({'top':'35%', 'left':'25%'}).blur();
      // Track search event in GA
      trackEvent('search', 'search', 'search_query', searchString.toLowerCase().trim().replace(/ /g, '_') );
      // Submit form
      searchForm.submit();
    }
  });

};
// Bind Header Search on page load
bindTabletHeaderSearch();

// Header Main Navigation
// $('header').on('click', '.header-main-menu > ul > li.menu-item-has-children > a', function(e) {
//   e.preventDefault();
//   e.stopPropagation();
  // Hide any other sub-menus
  // $('.header-main-menu > ul > li > .sub-menu').not( $(this).siblings('.sub-menu') ).fadeOut(100);
  // $('.header-main-menu .sub-menu').not( $(this).siblings('.sub-menu') ).parent().removeClass('active');
  // // Show sub-menu
  // $(this).parent().toggleClass('active');
  // $(this).siblings('.sub-menu').fadeToggle(100);
// });

/*=====  End of Tablet Header  ======*/

/*=====================================
=            Mobile Header            =
=====================================*/

// Mobile Search form
$('.mobile-main-menu-container').on('submit', '.search-form', function(e) {
  var searchForm = $(this),
      searchButton = $(this).find('.search-button'),
      searchInput = $(this).find('.search-field'),
      searchString = searchInput.val(),
      searchError = $('.mobile-main-menu-container').find('.search-error-message');

  if ( searchString.length < 3 ) {
    // Prevent form submit and show error
    e.preventDefault();
    searchError.fadeIn('fast');
    searchInput.focus();

    // Hide Mobile Search Form Error
    searchInput.on('input', function() {
      if ( $(this).val().length > 2 ) {
        searchError.fadeOut('fast');
      }
    });
  } else {
    // Hide error
    searchError.fadeOut('fast');
    // Change icon to spinner
    searchButton.find('.fa').removeClass('fa-search').addClass('fa-spinner fa-spin').css({'top':'28%', 'left':'23%'}).blur();
    // Submit form
    searchForm.submit();
  }
});

// Show Mobile Menu
function toggleMobileMenu(action) {
  var action = action || null,
      hamburger = $('.hamburger-icon'),
      searchIcon = $('.mobile-search-icon'),
      menu = $('.mobile-main-menu-container'),
      searchInput = $('.mobile-main-menu-container').find('.search-field'),
      globalNotification = $('.site-wide-notification');

  if (action == 'close') {
    hamburger.removeClass('show-close-icon');
    searchIcon.removeClass('hidden');
    menu.removeClass('active');
    searchInput.val('');
    $('body').removeClass('no-scroll');
    // Delay reset to wait for menu to hide
    setTimeout(function() {
      resetMobileMenu();
    }, 300);
    return;
  }

  globalNotification.toggleClass('hidden');
  hamburger.toggleClass('show-close-icon');
  searchIcon.toggleClass('hidden');
  menu.toggleClass('active');
  searchInput.val('');
  $('body').toggleClass('no-scroll');

  if ( !menu.hasClass('active') ) {
    // Delay reset to wait for menu to hide
    setTimeout(function() {
      resetMobileMenu();
    }, 300);
  }

  if (action == 'search') {
    searchInput.focus();
  }
};

function bindMobileNavigation() {
  var menu = $('.mobile-header-main-menu');

  // Top-level sub-menus
  menu.find('> ul > li.menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parent().toggleClass('active');
    // Hide out other menu items
    $(this).parent().siblings().not('.mobile-menu-donate').toggleClass('hidden');
    $('.mobile-header-main-menu .sub-menu').not( $(this).siblings('.sub-menu') ).removeClass('active');

    // Configure 'Back' link
    if ( $(this).siblings('.sub-menu').css('display') == 'block' ) {
      configureMobileBackButton('hide');
    } else {
      configureMobileBackButton('show');
    }

    $(this).siblings('.sub-menu').slideToggle(200);
  });

  // Secondary sub-menus
  menu.find('> ul > li.menu-item-has-children > ul > li.menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parent().toggleClass('active');
    // Hide out other menu items
    $(this).parent().siblings('.menu-item-has-children').removeClass('active').find('.sub-menu').slideUp(200);
    // Toggle this sub-menu
    $(this).siblings('.sub-menu').slideToggle(200);
  });

};
bindMobileNavigation();

function resetMobileMenu() {
  var menu = $('.mobile-header-main-menu');

  // Show all menu items
  menu.find('> ul > li').removeClass('hidden');
  // Remove active classes
  menu.find('li.menu-item-has-children').removeClass('active');
  // Remove active classes
  menu.find('.sub-menu').hide();
  // Hide search error
  $('.mobile-main-menu-container').find('.search-error-message').hide();

  // Hide back button
  configureMobileBackButton('hide');
};

function configureMobileBackButton(action) {

  if ( $('.mobile-menu-back-btn').length < 1 ) {
    $('<a href="#" class="mobile-menu-back-btn"><i class="fa fa-chevron-left fa-lg"></i>&nbsp;</a>').appendTo('.mobile-header-main-menu');
  }

  var action = action,
      btn = $('.mobile-menu-back-btn');

  // Unbind button clicks
  btn.off('click');

  if ( action == 'show' ) {
    // Show button
    btn.addClass('show');

    // Bind button click
    btn.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Slide up sub-menu
      $('.mobile-header-main-menu > ul > li:not(.hidden) > .sub-menu').slideUp(200, function() {
        $(this).parent().removeClass('active');
        // Hide button
        btn.removeClass('show');
        // Show all menu items
        $('.mobile-header-main-menu > ul > li.hidden').removeClass('hidden');
      });
    });
  } else if ( action == 'hide' ) {
    btn.removeClass('show');
    $('.mobile-header-main-menu li.menu-item-has-children').removeClass('active');
  }

};

// Hamburger Menu Icon
$('header').on('click', '.hamburger-icon', function(e) {
  e.preventDefault();
  e.stopPropagation();
  toggleMobileMenu();
});

// Mobile Search Icon
$('header').on('click', '.mobile-search-icon', function(e) {
  e.preventDefault();
  e.stopPropagation();

  if ( $('.mobile-main-menu-container').hasClass('active') ) {
    $('.mobile-main-menu-container').find('.search-field').focus();
  } else {
    toggleMobileMenu('search');
  }
});

$(window).resize(function() {
  // Hide mobile menu on window resize if larger than tablet
  if ( $(window).width() > 767 ) {
    toggleMobileMenu('close');
  }
});

/*=====  End of Mobile Header  ======*/

// Close Menus if click elsewhere
$('footer, .page-container').on('click', function() {
  // Close Tablet Menu
  $('.header-main-menu .sub-menu').parent().removeClass('active') ;
  $('.header-main-menu > ul > li > .sub-menu').fadeOut(100);
  // Close Mobile Menu
  toggleMobileMenu('close');
});